import InfosModal from "../modals/InfosModal.vue";
import HelpModal from "../modals/HelpModal";

export default {
    methods: {
        openModal(type, tab='faq'){
            if(type=='infos'){
                this.$buefy.modal.open({
                    component: InfosModal,
                    props: {
                        activeTab: tab
                    }
                })
            }
            if(type=='help'){
                this.$buefy.modal.open({
                    component: InfosModal,
                    props: {
                        activeTab: 'faq'
                    }
                })
            }
            dataLayer.push({
                event:'openModal',
                step:this.$store.get('general_data/current_step'),
                eventSource: 'mixin',
                modalTab:tab,
            })
        }
    }
}
